import axios from 'axios';
import moment from 'moment/moment';
import { dispatch } from 'nike-re-framejs';
import n1Client from '@/_http/axiosN1Client';

export function loadSportsWithDetail(sportId) {
    if (!vhSports.some(e => e.id === sportId)) {
        sportId = vhSports[0].id;
    }

    const matchParams = {
        limit: 1
    };
    const sportsDataResponse = n1Client.get('/v1/virtual-games/sports');
    const matchDataResponse = n1Client.get(`/v1/virtual-games/matches/${sportId}`, { params: matchParams });

    return axios.all([sportsDataResponse, matchDataResponse]).then(
        axios.spread((...responses) => {
            const sportData = responses[0];
            const matchData = responses[1];
            const data = {
                detail: matchData?.matches[0],
                serverTime: sportData?.serverTime,
                sports: sportData?.sports
            };
            return dispatch(['virtualGames.processSports', data]);
        })
    );
}

export function loadMatchDetail(sportId, startDate) {
    const matchParams = {
        startDate: startDate,
        limit: 1
    };
    return n1Client.get(`/v1/virtual-games/matches/${sportId}`, { params: matchParams }).then(matchData => {
        const data = {
            detail: matchData?.matches[0]
        };
        return dispatch(['virtualGames.processMatch', data]);
    });
}

export const vhSports = [
    { id: 128, name: 'dostihy' },
    { id: 129, name: 'tenis' },
    { id: 130, name: 'cyklistika' },
    { id: 131, name: 'futbal' },
    { id: 132, name: 'moto' }
];

export const vhSportMap = {
    dostihy: 128,
    tenis: 129,
    cyklistika: 130,
    futbal: 131,
    moto: 132
};

export const vhSportMapReversed = {
    128: 'dostihy',
    129: 'tenis',
    130: 'cyklistika',
    131: 'futbal',
    132: 'moto'
};

export const vhSportIconMap = {
    128: 'vh_dostihy',
    129: 'tenis',
    130: 'cyklistika',
    131: 'futbal',
    132: 'motorizmus'
};

// FOR TESTING
// const afterTime = moment()
//     .startOf('day')
//     .add(21, 'hour');
// const beforeTime = moment()
//     .startOf('day')
//     .add(22, 'hour');

const afterTime = moment()
    .startOf('day')
    .add(7, 'hour');
const beforeTime = moment()
    .startOf('day')
    .add(22, 'hour');

let currentTime = moment();
export let timeToHide = currentTime.isBetween(afterTime, beforeTime);
